<template>
    <div class="geometric-search" v-if="show" @click="GeometricSearch">
        <img :src="url" alt="">
        <span>模型智能检索</span>
    </div>
</template>

<script>
import {DomainService} from '@/libs'

export default {
    data() {
        return {
            url: `${DomainService.PublicPath}resource/images/icon/jihe.png`,
            show: true,
        }
    },
    mounted() {
       
    },
    methods: {

        GeometricSearch() {
            let url = `${DomainService.Web}/search/geometric`;
            // let url = `http://localhost:8010/search/geometric`;
            window.open(url);
        }
    }
}
</script>

<style lang="less" scoped>
    .geometric-search{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        line-height: 18px;
        color: #0989c5;
        cursor: pointer;
        position: absolute;
        right: 110px;
        top: -2px;
        z-index: 999;
        img{
            height: 23px;
            margin-bottom: 4px;
        }
    }
</style>
